/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

$circle-size: 44px;
$circle-background: v(progressBackgroundColor);
$circle-color: v(progressColor);
$inset-size: 36px;
$inset-color: v(backgroundColor);
$transition-length: 1s;

.#{$prefix}circle-center-wrapper {
  position: absolute;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &__icon {
    color: v(iconColor);
  }
  &__text {
    color: v(textColor);
  }
}

.#{$prefix}progress-circle {
  //margin: 20px auto;
  width: $circle-size;
  height: $circle-size;
  position: relative;
  overflow: hidden;

  &--icon {
    &:hover {
      background-color: v(progressBackgroundColorOnHover);

      eon-ui-icon {
        color: var(--iconColorOnHover);
      }

      .#{$prefix}progress-circle__slice {
        .#{$prefix}progress-circle__fill {
          background-color: v(progressColorOnHover);
        }
      }
    }
  }

  background-color: $circle-background;
  border-radius: 50%;
  .#{$prefix}progress-circle__slice,
  .#{$prefix}progress-circle__fill {
    width: $circle-size;
    height: $circle-size;
    position: absolute;
    -webkit-backface-visibility: hidden;
    transition: transform $transition-length;
    border-radius: 50%;
  }

  .#{$prefix}progress-circle__slice {
    clip: rect(0px, $circle-size, $circle-size, $circle-size * 0.5);

    .#{$prefix}progress-circle__fill {
      clip: rect(0px, $circle-size * 0.5, $circle-size, 0px);
      background-color: $circle-color;

      &--error {
        background-color: v(eon-red);
      }
    }
  }

  .#{$prefix}progress-circle__overlay {
    width: $inset-size;
    height: $inset-size;
    position: absolute;
    margin-left: ($circle-size - $inset-size) * 0.5;
    margin-top: ($circle-size - $inset-size) * 0.5;
    background-color: $inset-color;
    border-radius: 50%;
  }

  $i: 0;
  $increment: customDivide(180deg, 100);

  @while $i <= 100 {
    &[data-progress="#{$i}"] {
      .#{$prefix}progress-circle__slice.#{$prefix}full,
      .#{$prefix}progress-circle__fill {
        transform: rotate($increment * $i);
      }

      .#{$prefix}progress-circle__fill.#{$prefix}progress-circle__bar {
        transform: rotate($increment * $i * 2);
      }

      $i: $i + 1;
    }
  }
  &[data-progress="100"] {
    .#{$prefix}progress-circle__slice {
      .#{$prefix}progress-circle__fill {
        background-color: v(progressSuccessColor);
      }
    }

    .#{$prefix}circle-center-wrapper {
      &__icon {
        color: v(iconSuccessColor);
      }
      &__text {
        color: v(iconSuccessColor);
      }
    }
  }
}
